<app-modal-template
  [size]="data.size"
  [hasCloseButton]="data.dismissable"
  (closeButtonClicked)="close(graphicModalCloseResultEnum.CLOSE)"
>
  <app-pencil-icon
    *ngIf="data.imageVariant === graphicModalVariantEnum.ICON"
    content-img
    class="graphic-modal-icon"
    [name]="data.icon!.name"
    [type]="data.icon!.type"
    [outlined]="data.icon!.outlined ?? false"
  ></app-pencil-icon>
  <img
    *ngIf="data.imageVariant === graphicModalVariantEnum.IMAGE"
    content-img
    class="graphic-modal-bleed"
    [src]="data.bleedImage!.url"
    [attr.alt]="data.bleedImage!.alt ?? ''"
    loading="eager"
    decoding="async"
  />
  <div content-description class="graphic-modal-body">
    <div class="graphic-modal-title">{{ data.title }}</div>
    <div *ngIf="data.description" class="graphic-modal-description-text" [innerHtml]="data.description"></div>
  </div>
  <div content-actions class="graphic-modal-actions">
    <app-pencil-button
      *ngIf="data.secondaryButtonConfig as secondaryButtonConfig"
      theme="secondary-outline"
      [icon]="secondaryButtonConfig.icon"
      [iconConfig]="{ type: secondaryButtonConfig.iconType, outlined: secondaryButtonConfig.outlined }"
      [label]="secondaryButtonConfig.label"
      (clickEvent)="close(graphicModalCloseResultEnum.SECONDARY)"
    ></app-pencil-button>
    <app-pencil-button
      *ngIf="data.primaryButtonConfig as primaryButtonConfig"
      [theme]="primaryButtonConfig.danger ? 'danger' : 'primary'"
      [icon]="primaryButtonConfig.icon"
      [iconConfig]="{ type: primaryButtonConfig.iconType, outlined: primaryButtonConfig.outlined }"
      [label]="primaryButtonConfig.label"
      (clickEvent)="close(graphicModalCloseResultEnum.PRIMARY)"
    ></app-pencil-button>
  </div>
</app-modal-template>
